import './assets/css/theme.css';
import './assets/css/custom.css';

import { BrowserRouter as Router } from "react-router-dom";
import { useEffect } from "react";

// Components
import RouterView from "./RouterView";
import Navbar from "./components/common/Navbar/Navbar";
import Footer from './components/common/Footer/Footer';

// Google ReCaptcha service for forms.
import ReactRecaptchaV3 from 'react-google-recaptcha3';
import ScrollToTop from './components/common/ScrollToTop';

// Public key... not sensitive information.
const reCaptchaSiteKey = "6LfIn-klAAAAAK3dN7M9nmMrOJDQGXjGdSxd1aRr";

export default function App() {
    // load google recaptcha3 script
    useEffect(() => {
        // Start monitoring client, to determine if a robot.
        ReactRecaptchaV3.init(reCaptchaSiteKey).then(
            (status) => {
                // TODO: Remove in production.
                console.log(`G-ReCaptcha V3 Status: ${status}`);
            }
        );
    }, []);

    return (
        <Router>
            <div id="App">
                { /* Example Persistent Component i.e. It displays for every page. */ }
                <Navbar />
                { /* Rendered Pages: Modify this file to add pages/routes/views. */}
                <ScrollToTop/>
                <RouterView />
                <Footer />
            </div>
        </Router>

    );
}
